export default(() => {

    const global = {
        inputs: {},
        components: {},
        pageData: {}
    };

    function initialise(config){
        _cacheDom();
        _cachePageData(config);
        _bindEvents();
        _initialiseComponents();
    }

    function _cacheDom() {
        global.inputs.accountOwnerCheckboxes = [...document.querySelectorAll('[data-account-holder-confirm-checkbox]')];

        global.components.submitButtons = [...document.querySelectorAll('[data-submit-button]')];

        global.components.progressBar = document.querySelector('[data-progress-bar]');
        global.components.investmentDiamond = document.querySelector('[data-investmentdiamond]');
        global.components.projectionDataListDesktop = document.querySelector('[data-projectionsdatalistdesktop]');
        global.components.projectionDataListMobile = document.querySelector('[data-projectionsdatalistmobile]');
        global.components.projectionDatalistMobile = document.querySelector('[data-projectionsdatalistmobile]');
        global.components.contributionAmountMobile = document.querySelector('[data-contributionamountmobile]');
        global.components.contributionProjectionMobile = document.querySelector('[data-contributionprojectionamountmobile]');
    }
    
    function _cachePageData(config){
        global.pageData = {
            portfolioId: document.querySelector('[data-portfolioid]').value,
            customerId: document.querySelector('[data-customerid]').value,
            postUrl: document.querySelector('[data-posturl]').value,
            ...config
        };
    }

    function _bindEvents () {
        if (global.pageData.isRecurringPayment) {
            global.inputs.accountOwnerCheckboxes.forEach((checkbox) => checkbox.addEventListener('change', toggleSubmitButtonDisabled));
        }
    }
    
    function _initialiseComponents(){
        
        _setLoadingState(true);
        initialiseProgressBar();

        global.components.projectionDataListDesktop.items = global.components.projectionDataListMobile.items =  [{
            'label': 'If markets perform better',
            'value': '-',
            'separator': true
        }, {    
            'label': 'If markets perform worse',
            'value': '-',
            'separator': true
        }];
    
        _getPerformance()
            .then(_updateProjections);
        
        toggleSubmitButtonDisabled();
    }

    function initialiseProgressBar () {
        const recurringUrlFlag = global.pageData.isRecurringPayment ? 'Recurring' : '';
        const allSteps = [
            {
                'label': '1',
                'titleprop': 'Your Options',
                'state': 'complete',
                onclickprop: () => {
                    window.location = `${window.location.origin}${global.components.progressBar.getAttribute('data-options-url') + recurringUrlFlag}/${global.pageData.portfolioId}`;
                },
            },
            {
                'label': '2',
                'titleprop': 'Your Details',
                'state': 'complete',
                onclickprop: () => {
                    window.location = `${window.location.origin}${global.components.progressBar.getAttribute('data-details-url') + recurringUrlFlag}/${global.pageData.portfolioId}`;
                },
            },
            {
                'label': '3',
                'titleprop': 'Bank Details',
                'state': 'complete',
                onclickprop: () => {
                    window.location = `${window.location.origin}${global.components.progressBar.getAttribute('data-bankdetails-url') + recurringUrlFlag}/${global.pageData.portfolioId}`;
                },
            },
            {
                'label': global.pageData.hasEnrolled ? '2' : '4',
                'titleprop': 'Confirmation',
                'state': 'selected'
            }
        ];            

        global.components.progressBar.steps = global.pageData.hasEnrolled
            ? [allSteps[0], allSteps[allSteps.length - 1]]
            : [...allSteps];
    }

    function toggleSubmitButtonDisabled (event) {
        if (global.inputs.accountOwnerCheckboxes.length === 0) {
            return;
        }

        const accountOwnerCheckbox = event?.currentTarget ?? global.inputs.accountOwnerCheckboxes[0];

        global.components.submitButtons.forEach((button) => button.disabledProp = !accountOwnerCheckbox.checked);
        global.inputs.accountOwnerCheckboxes.forEach((checkbox) => checkbox.checked = accountOwnerCheckbox.checked);
    }

    function _getPerformance() {
        const config = {
            data: {
                portfolioID: global.pageData.portfolioId,
                contributorID: global.pageData.customerId,
                contributionValue: global.pageData.contributionAmount,
                isRecurringPayment: global.pageData.isRecurringPayment,
            },
            contentType: 'application/json',
            url: global.pageData.postUrl
        };

        return wealthify.request.send(config);
    }

    function _updateProjections(projectionResponse){
        if(global.pageData.isRecurringPayment){
            global.components.investmentDiamond.totalinvestmentvalue = projectionResponse.Invest;
            global.components.contributionAmountMobile.innerHTML = wealthify.type.number.toCurrency(projectionResponse.Invest);
        } else {
            global.components.contributionAmountMobile.innerHTML = wealthify.type.number.toCurrency(projectionResponse.InitialInvestment);
        }

        global.components.investmentDiamond.projectedvalue = projectionResponse.PredictedValue;

        global.components.projectionDataListDesktop.items = global.components.projectionDataListMobile.items = [{
            'label': 'If markets perform better',
            'value':  wealthify.type.number.toCurrency(projectionResponse.PredictedValueUpper),
            'separator': true
        }, {    
            'label': 'If markets perform worse',
            'value': wealthify.type.number.toCurrency(projectionResponse.PredictedValueLower),
            'separator': true
        }];

        global.components.contributionProjectionMobile.innerHTML = wealthify.type.number.toCurrency(projectionResponse.PredictedValue);

        _setLoadingState(false);
    }

    function _setLoadingState(isLoading){
        global.components.investmentDiamond.loading = isLoading;
    }


    return {initialise};
})();